import React from "react";
import { Box, Typography, Link } from "@mui/material";
import BaseDrawer from "./BaseDrawer";

interface Song {
  title: string;
  artist: string;
  lyric: string;
  link?: string;
}

interface LyricsDrawerProps {
  open: boolean;
  handleClose: () => void;
  song: Song | null;
}

const LyricsDrawer: React.FC<LyricsDrawerProps> = ({
  open,
  handleClose,
  song,
}) => {
  if (!song) return null;

  return (
    <BaseDrawer open={open} handleClose={handleClose} height="80vh" background="#ffffff">
      <Box sx={{ px: 0, pb: 4, height: "100%", flex: 1 }}>
        {/* ヘッダー */}
        <Box sx={{ mb: 2, px: 2 }}>
          <Typography variant="h6" fontWeight="bold" sx={{ color: "#53696d" }}>
            {song.title}
          </Typography>
          <Typography variant="body2" sx={{ color: "#607d7d" }}>
            {song.artist}
          </Typography>
        </Box>

        {/* スクロール可能な歌詞コンテンツ */}
        <Box
          data-scrollable
          sx={{
            overflow: "auto",
            height: "calc(80vh - 120px)",
            px: 0,
            mx: 0,
            "&::-webkit-scrollbar": {
              width: 6,
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "transparent",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#b4bdbb",
              borderRadius: 3,
            },
          }}
        >
          <Typography
            variant="body2"
            sx={{
              whiteSpace: "pre-line",
              color: "#2c3f42",
              lineHeight: 1.8,
              px: 2,
              pr: 1,
            }}
          >
            {song.lyric}
          </Typography>

          {song.link && (
            <Box mt={4} sx={{ px: 2, pr: 1 }}>
              <Typography variant="caption" sx={{ color: "#607d7d", mb: 0.5 }}>
                引用元:
              </Typography>
              <Link
                href={song.link}
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                sx={{ color: "#4A4FD4", fontSize: "0.75rem", display: "block" }}
              >
                {song.link}
              </Link>
            </Box>
          )}
        </Box>
      </Box>
    </BaseDrawer>
  );
};

export default LyricsDrawer;
